module.exports = __webpack_public_path__ + "static/media/10.fc1d54f7.png";